const EnergoSwitcher = ({options, handler, selected}) => {

    return (
        <div className="energo-switcher">
            {options && options.length > 0 && options.map(opt => (
                <div 
                    className={`item ${selected === opt.id && "selected"}`}
                    key={opt.id} 
                    onClick={() => handler(opt)}
                >
                    {opt.label}
                </div>
            ))}
        </div>
    )
}
export default EnergoSwitcher;